import { useMutation, useQueryClient } from "react-query";

import { favouriteItemsKey } from "../../queries";
import { updateFavourite } from "./updateFavourite.fetcher";

export function useUpdateFavouriteMutation() {
  const queryClient = useQueryClient();

  return useMutation(updateFavourite, {
    onSettled: () => {
      queryClient.invalidateQueries(favouriteItemsKey);
    },
  });
}
